<script>
	import { slide } from "svelte/transition";

	import model from "../../stores/modelStore";
	import { registerPageComplete } from "../../tealium";
	import { projectSettings } from "../../config";
	import { isValid } from "../../validation";

	import Form from "../../components/Form.svelte";
	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	// props
	export let persistUrl = null;
	export let pageName = null;
	export let pageTitle = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	let buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="payment-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Part 6: Your Bank Account Details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<FormRowColumn>
				<YesNoGroup
					required
					{disabled}
					name="hasBankAccount"
					label="Do you have a bank account in your name?"
					bind:value={$model.hasBankAccount}
				/>
			</FormRowColumn>

			{#if $model.hasBankAccount === "No"}
				<div transition:slide|local>
					<p>
						If no, please contact Shine Lawyers to tell them how you would like any compensation money to be
						paid to you.
					</p>
				</div>
			{/if}

			{#if $model.hasBankAccount === "Yes"}
				<div transition:slide|local>
					<FormRowColumn>
						<TextInput required {disabled} label="Bank Name" bind:value={$model.bankDetails.bankName} />
					</FormRowColumn>

					<FormRowColumn>
						<TextInput
							required
							{disabled}
							maxlength="250"
							label="Account Name"
							bind:value={$model.bankDetails.accountName}
						/>
					</FormRowColumn>

					<FormRow>
						<FormColumn cols="4">
							<TextInput
								required
								{disabled}
								maxlength="6"
								label="BSB"
								bind:value={$model.bankDetails.bsb}
							/>
						</FormColumn>
						<FormColumn cols="8">
							<TextInput
								required
								{disabled}
								maxlength="20"
								label="Account Number"
								bind:value={$model.bankDetails.accountNumber}
							/>
						</FormColumn>
					</FormRow>

					<p>If your bank details change, you need to tell us as soon as possible.</p>
				</div>
			{/if}
		</div>

		<FormRowColumn rowClass="confirmation-hide">
			<NavigationButtons bind:buttons />
		</FormRowColumn>
	</Form>
</PageSection>

<style>
</style>
